import React,{useState, useEffect} from "react";
import './Statements.css'
import { Trans, useTranslation} from 'react-i18next'
import downloadicon from './../../../../images/downloadicon.png'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import Select from 'react-select'

function Statements() {
    const {t, i18n } = useTranslation();
    const cookies = new Cookies(null ,{ path: '/' });
    const [view,setView] = useState("")

    const dummydata = [{Month:"July 2024",Name:"July2024StatementRun_N3rveEntGenNeoAECampaign-standard-EUR.zip"},
    {Month:"July 2024",Name:"July2024StatementRun_N3RVEEntertainmentLLC-standard-EUR.zip"},
    {Month:"June 2024",Name:"June2024StatementRun_N3rveEntGenNeoAECampaign-standard-EUR.zip"},
    {Month:"July 2024",Name:"June2024StatementRun_N3RVEEntertainmentLLC-standard-EUR.zip"}]

    const viewOptions = [{value:'2024', label:'2024'},
    {value:'2023', label:'2023'},
    {value:'2022', label:'2022'},
    {value:'2021', label:'2021'}]

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    
      const changeViewOption = (data) =>{
        setView(data)
      }

    const colourStyles = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'rgba(0,0,0,16%)',
        width: '9.43em',
        height: '3em',
        borderRadius:'4px',
        color:'rgba(255, 255, 255, 1)',
        marginTop:'0.5em',
        "&:hover": {
          backgroundColor: "rgba(254,254,254,20%)"
        }
      }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#18191F' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em',
            "&:hover": {
              backgroundColor: 'rgba(0,0,0,100%)'
            }
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)'}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'}),
        hover : styles =>({
                                          backgroundColor:'rgba(255,255,255,16%)',
          })
      };
    
    useEffect(()=>{
        topFunction()
    },[])
    
    return (
        <div>
           <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                <div className="ViewTxt">
                    View
                </div>

                <Select options={viewOptions} value={view} onChange={changeViewOption} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    placeholder="2024"
                    styles={
                      colourStyles
                    }
                    />

           </div>

           <div style={{display:'flex',flexDirection:'column',borderRadius:'8px',overflow:'hidden',marginTop:'1.5em'}}>
                <div style={{display:'flex',flexDirection:'row',paddingTop:'0.68em',paddingBottom:'0.68em',backgroundColor:'rgba(255,255,255,8%)'}}>
                    <div className="ColumnHeader" style={{width:'28%',marginLeft:'1em'}}>
                        Month
                    </div>

                    <div className="ColumnHeader">
                        Name
                    </div>
                </div>

                {
                    dummydata.map((dummy)=>{
                        return (
                            <div style={{display:'flex',flexDirection:'row',paddingTop:'0.843em',paddingBottom:'0.843em',backgroundColor:'rgba(255,255,255,3%)',position:'relative'}}>
                            <div className="ColumnHeader" style={{width:'28%',marginLeft:'1em',color:'#FFFFFF'}}>
                                {dummy.Month}
                            </div>
        
                            <div className="ColumnHeader" style={{color:'#FFFFFF',textDecoration:'underline'}}>
                                {dummy.Name}
                            </div>

                            <img src={downloadicon} style={{position:'absolute',right:'2em',cursor:'pointer'}}/>
                        </div>
                        )
                    })
                }
           </div>


        </div>
       
    );
}

export default Statements;